import { createClient } from '@base44/sdk';
import { appParams } from '@/lib/app-params';

const { appId, token, functionsVersion } = appParams;

//Create a client with authentication required.
// SECURITY: serverUrl is hardcoded to '' so all authenticated traffic goes to
// the platform origin — never to a client-controlled URL parameter that could
// exfiltrate the session token.
export const base44 = createClient({
  appId,
  serverUrl: '',
  token,
  functionsVersion,
  requiresAuth: false
});